import React from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';
import { TCostFormulaToggleProps } from 'components/cost-formula-toggle';
import { ECostFormulaParamType } from 'store/deal-evaluation/types';

const { activeBackground, darkInputBorder, primary, white, fontBody, globalInputSelectedBg } = colors;

const CostFormulaToggleStyled = styled.div``;

const Title = styled.div`
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const fontWeightHigh = 600;
const fontWeightLow = 500;

const Button = styled.button<{ active: boolean }>`
  min-height: 24px;
  padding: 0px 8px;
  min-width: 50px;
  border: 0.5px solid ${darkInputBorder};
  color: ${props => (props.active ? primary : fontBody)};
  background-color: ${props => (props.active ? activeBackground : white)};
  font-weight: ${props => (props.active ? fontWeightHigh : fontWeightLow)};
  line-height: 1em;

  :active,
  :focus {
    outline: none;
  }

  :hover {
    cursor: pointer;
    background-color: ${globalInputSelectedBg} !important;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${Button}:first-of-type {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  ${Button}:last-of-type {
    border-left: none;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;

export default ({ selectedCostFormulaType, setCostFormulaType, showTitle = true }: TCostFormulaToggleProps) => {
  return (
    <CostFormulaToggleStyled>
      {showTitle ? <Title>Cost Formula</Title> : null}
      <ButtonContainer>
        <Button
          onClick={() => setCostFormulaType(ECostFormulaParamType.TRUE_COST)}
          active={selectedCostFormulaType === ECostFormulaParamType.TRUE_COST}
        >
          True Cost
        </Button>
        <Button
          onClick={() => setCostFormulaType(ECostFormulaParamType.ITP)}
          active={selectedCostFormulaType === ECostFormulaParamType.ITP}
        >
          ITP
        </Button>
      </ButtonContainer>
    </CostFormulaToggleStyled>
  );
};
